import TimerList from "@/constants/TimerList";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const timeToAmPm = (time: string, timezone: string) => {
    return TimerList.find(
      (t) => t.value === format(toZonedTime(time, timezone), "HH:mm").toString()
    )?.label;
  };